import { connect } from 'react-redux';
import SlipDeleteConfirmationModal from './SlipDeleteConfirmationModal';
import { slipDeleteConfirmed, slipDeleteCancelled } from '../../bettingBuddy/actions';

export default connect(null, {
  confirm: slipDeleteConfirmed,
  cancel: slipDeleteCancelled
})(SlipDeleteConfirmationModal);
